// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bjykj{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-bhqys{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-cauxr{grid-column:span 6}.assets-scss-gridstyleGrid-col3-ptfrn{grid-column:span 3}.assets-scss-gridstyleGrid-col4-ysjpg{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bpdei{grid-column:span 9}.assets-scss-gridstyleGrid-col12-mxrac{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-lagky{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bjykj",
	"grid": "assets-scss-gridstyleGrid-grid-bhqys",
	"col6": "assets-scss-gridstyleGrid-col6-cauxr",
	"col3": "assets-scss-gridstyleGrid-col3-ptfrn",
	"col4": "assets-scss-gridstyleGrid-col4-ysjpg",
	"col9": "assets-scss-gridstyleGrid-col9-bpdei",
	"col12": "assets-scss-gridstyleGrid-col12-mxrac",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-lagky"
};
module.exports = ___CSS_LOADER_EXPORT___;
